import React, { Component } from "react"
import { removeStorage, getStorage } from "../components/CustomComponent.js"
import "../assets/css/bootstrap.css"

export default class Loading extends Component {
  componentDidMount() {
    window.location.href = "/login";
    // const token = localStorage.getItem("token");
    // const user = localStorage.getItem("user");
    // if (token) {
    //   if (!user) {
    //     removeStorage();
    //     window.location.href = "/index";
    //   } else if (user.user_type === "customer") {
    //     window.location.href = "/user/list-rent";
    //   } else {
    //     localStorage.setItem("locale", "th");
    //     window.location.href = "/admin/dashboard";
    //   }
    // } else {
    //   removeStorage();
    //   window.location.href = "/index";
    // }
  }
  render() {
    return <div></div>
  }
}
